const socialMediaLinks = {
  github: "https://github.com/estherkim99",
  linkedin: "https://www.linkedin.com/in/yoo-kyung-kim/",
  gmail: "estherkim1721@gmail.com",
  facebook: "https://www.facebook.com/kimyk326",
};

const homeTexts = {
  intro:
    "I'm an aspiring software engineer studying computer science at Brown University, with interests in machine learning, image processing, and web development.",
};

const projectTexts = {
  intro:
    "Please contact me at estherkim1721@gmail.com for access to private github repositories and code samples on Dropbox.",
  note: "",
};

const cvTexts = {
  intro: "",
  note: "",
};

const apiInfo = {
  domain: "https://estherkim99-portfolio-api.herokuapp.com",
};


const cvData = {
  schools: [
    {
      "id": 1,
      "location": {
        "id": 1,
        "city": "Providence",
        "state": "Rhode Island",
        "country": "United States",
        "online": false
      },
      "name": "Brown University",
      "level": "Postsecondary",
      "degree_type": "Bachelor's Degree",
      "program_one": "Sc.B. in Computer Science",
      "program_two": "A.B. in Engineering",
      "program_three": null,
      "start_date": "2017-09-05",
      "end_date": "2021-12-31",
      "status": "Break"
    },
    {
      "id": 2,
      "location": {
        "id": 2,
        "city": "Seoul",
        "state": null,
        "country": "South Korea",
        "online": false
      },
      "name": "Yonsei University",
      "level": "Postsecondary",
      "degree_type": null,
      "program_one": "Yonsei International Summer School",
      "program_two": null,
      "program_three": null,
      "start_date": "2018-07-03",
      "end_date": "2018-08-16",
      "status": "Completed"
    },
    {
      "id": 3,
      "location": {
        "id": 3,
        "city": "Milan",
        "state": null,
        "country": "Italy",
        "online": false
      },
      "name": "American School of Milan",
      "level": "Secondary",
      "degree_type": "High School",
      "program_one": "High School",
      "program_two": "International Baccalaureate Diploma",
      "program_three": null,
      "start_date": "2013-09-02",
      "end_date": "2017-06-11",
      "status": "Completed"
    }
  ],
  works: [
    {
      "name": "Center for Computation and Visualization @ Brown University",
      "role": "Data Science Intern",
      "role_description": "Extracted data from IRS tax return documents in PDF format by performing OCR using Tesseract.\r\nAnalyzed the extracted tax return data for charitable institutions using Natural Language Toolkit for Python to measure inequality in financial support from schools from local community groups.",
      "start_date": "2020-07-13",
      "end_date": "2020-12-31",
      "company_link": "https://www.taggers.io",
      "stack": [
        { "name": "Python" },
        { "name": "Tesseract" },
        { "name": "NLTK" }
      ],
      "location": {
        "id": 2,
        "city": "Providence",
        "state": "RI",
        "country": "United States",
        "online": false
      },
    },
    {
      "id": 1,
      "location": {
        "id": 2,
        "city": "Seoul",
        "state": null,
        "country": "South Korea",
        "online": false
      },
      "stack": [
        {
          "id": 2,
          "category": [
            {
              "id": 1,
              "name": "Web Development"
            }
          ],
          "name": "Django",
          "proficiency": "intermediate"
        },
        {
          "id": 3,
          "category": [
            {
              "id": 1,
              "name": "Web Development"
            }
          ],
          "name": "Vue.js",
          "proficiency": "basic"
        },
        {
          "id": 6,
          "category": [
            {
              "id": 1,
              "name": "Web Development"
            }
          ],
          "name": "Nuxt.js",
          "proficiency": "basic"
        },
        {
          "id": 12,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "Python",
          "proficiency": "advanced"
        },
        {
          "id": 18,
          "category": [
            {
              "id": 3,
              "name": "DevOps Tools"
            }
          ],
          "name": "Docker",
          "proficiency": null
        },
        {
          "id": 20,
          "category": [
            {
              "id": 3,
              "name": "DevOps Tools"
            }
          ],
          "name": "Git",
          "proficiency": null
        },
        {
          "id": 24,
          "category": [
            {
              "id": 4,
              "name": "Databases"
            }
          ],
          "name": "MariaDB",
          "proficiency": null
        },
        {
          "id": 29,
          "category": [
            {
              "id": 5,
              "name": "Computer Vision"
            }
          ],
          "name": "OpenCV",
          "proficiency": null
        },
        {
          "id": 30,
          "category": [
            {
              "id": 5,
              "name": "Computer Vision"
            }
          ],
          "name": "Tesseract",
          "proficiency": null
        },
        {
          "id": 31,
          "category": [
            {
              "id": 5,
              "name": "Computer Vision"
            }
          ],
          "name": "scikit-learn",
          "proficiency": null
        },
        {
          "id": 32,
          "category": [
            {
              "id": 5,
              "name": "Computer Vision"
            }
          ],
          "name": "TensorFlow",
          "proficiency": null
        },
        {
          "id": 33,
          "category": [
            {
              "id": 5,
              "name": "Computer Vision"
            }
          ],
          "name": "Keras",
          "proficiency": null
        },
        {
          "id": 34,
          "category": [
            {
              "id": 6,
              "name": "Data Science"
            }
          ],
          "name": "pandas",
          "proficiency": null
        },
        {
          "id": 35,
          "category": [],
          "name": "statsmodels",
          "proficiency": null
        }
      ],
      "name": "Taggers",
      "role": "Software Engineering Intern (Fullstack)",
      "role_description": " Optimized image processing algorithm for selecting aesthetically pleasing images. Reduced runtime by 60%; achieved 0.95 precision and 0.90 recall.\r\nShortened data retrieval speed by setting up scheduled tasks to periodically save ad statistics and developing API to access the stored data with Django. \r\n Architeted a database to effectively store high volume of advertisement data from various platforms including Google Ads and Facebook Ads.\r\n Analyzed the ad marketing statistics for performance optimization by building rergrerssion models. \r\n Developed reusable Vue chart components with D3 for data visualization. \r\n Formulated a two-year plan to integrate machine learning to enhance the company’s automized ad generation and analytics program, securing government funding of ₩700M (approx. $0.6M) through the Tech Incubator Program for Startup.",
      "start_date": "2020-07-13",
      "end_date": "2020-12-31",
      "company_link": "https://www.taggers.io"
    },
    {
      "id": 2,
      "location": {
        "id": 2,
        "city": "Seoul",
        "state": null,
        "country": "South Korea",
        "online": false
      },
      "stack": [
        {
          "id": 15,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "Java",
          "proficiency": "advanced"
        },
        {
          "id": 19,
          "category": [
            {
              "id": 3,
              "name": "DevOps Tools"
            }
          ],
          "name": "Maven",
          "proficiency": null
        },
        {
          "id": 20,
          "category": [
            {
              "id": 3,
              "name": "DevOps Tools"
            }
          ],
          "name": "Git",
          "proficiency": null
        },
        {
          "id": 23,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "SQL",
          "proficiency": "intermediate"
        }
      ],
      "name": "Logpresso",
      "role": "Software Engineering Intern (Backend)",
      "role_description": "Developed crawler modules in Java to automize data collection from online security rule databases. \r\n Parsed and normalized network threat management system log, enhancing the integrity and usability of data collected.",
      "start_date": "2019-06-24",
      "end_date": "2019-08-23",
      "company_link": "https://ko.logpresso.com"
    },

  ],

  leadership: [
    {
      "id": 1,
      "location": {
        "id": 1,
        "city": "Providence",
        "state": "Rhode Island",
        "country": "United States",
        "online": false
      },
      "keywords": [],
      "name": "Brown University Korean International Student Association",
      "roles": {
        "roles": [
          {
            "name": "Vice-President"
          },
          {
            "name": "Senior-Advisor"
          },
          {
            "name": "Treasurer"
          }
        ]
      },
      "description": "Managed annual budget and secured funding from Brown University Undergraduate Finance Board, reducing the yearly expenditure by 7.9% while doubling the number of events held for academic year 2019-20, compared to the previous year.\r\nStrengthened the rapport with the alumni group, Brown Club of Korea, by coordinating the organization’s first networking event."
    }
  ],

  skills: {
    "Web Development": [
      "Django",
      "Hugo",
      "Next.js",
      "React.js",
      "Vue.js",
      "Nuxt.js",
      "Bootstrap"
    ],
    "Programming Languages": [
      "HTML",
      "CSS",
      "JavaScript",
      "PHP",
      "Python",
      "C",
      "Java",
      "C++",
      "OCaml",
      "Scala",
      "SQL",
      "Markdown",
      "MATLAB"
    ],
    "DevOps Tools": [
      "Docker",
      "Maven",
      "Git",
      "Vagrant",
      "Heroku",
      "Firebase"
    ],
    "Databases": [
      "MySQL",
      "MariaDB",
      "Firebase",
      "SQLite",
      "PostgreSQL"
    ],
    "Computer Vision": [
      "OpenCV",
      "Tesseract",
      "scikit-learn",
      "TensorFlow",
      "Keras"
    ],
    "Data Science": [
      "pandas",
      "D3.js"
    ],
    "Computer Graphics": [
      "OpenGL",
      "WebGL"
    ]
  }
}


const projectData = {
  "academic": [
    {
      "id": 1,
      "keywords": [
        {
          "id": 5,
          "name": "Data Science"
        }
      ],
      "stack": [
        {
          "id": 10,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "JavaScript",
          "proficiency": "advanced"
        },
        {
          "id": 12,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "Python",
          "proficiency": "advanced"
        },
        {
          "id": 23,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "SQL",
          "proficiency": "intermediate"
        },
        {
          "id": 27,
          "category": [
            {
              "id": 4,
              "name": "Databases"
            }
          ],
          "name": "SQLite",
          "proficiency": null
        },
        {
          "id": 34,
          "category": [
            {
              "id": 6,
              "name": "Data Science"
            }
          ],
          "name": "pandas",
          "proficiency": null
        },
        {
          "id": 35,
          "category": [],
          "name": "statsmodels",
          "proficiency": null
        },
        {
          "id": 40,
          "category": [
            {
              "id": 6,
              "name": "Data Science"
            }
          ],
          "name": "D3.js",
          "proficiency": null
        }
      ],
      "location": {
        "city": null,
        "state": null,
        "country": null
      },
      "course": {
        "id": 24,
        "school": {
          "id": 1,
          "location": {
            "id": 1,
            "city": "Providence",
            "state": "Rhode Island",
            "country": "United States",
            "online": false
          },
          "name": "Brown University",
          "level": "Postsecondary",
          "degree_type": "Bachelor's Degree",
          "program_one": "Sc.B. in Computer Science",
          "program_two": "A.B. in Engineering",
          "program_three": null,
          "start_date": "2017-09-05",
          "end_date": "2021-12-31",
          "status": "Break"
        },
        "keywords": [],
        "course_code": "CSCI1951A",
        "subject": "Computer Science",
        "name": "Data Science",
        "description": "",
        "TA": false,
        "professor_info": null,
        "semester_level": 6
      },
      "name": "Analysis of Relationship between Home Values and Airbnb Success Rate",
      "team_size": 1,
      "start_date": "2020-02-01",
      "end_date": "2020-05-01",
      "description": "",
      "project_url": "",
      "source_url": "",
      "extra": null
    },
    {
      "id": 5,
      "keywords": [],
      "stack": [
        {
          "id": 17,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "Scala",
          "proficiency": "basic"
        }
      ],
      "location": {
        "city": null,
        "state": null,
        "country": null
      },
      "course": {
        "id": 2,
        "school": {
          "id": 1,
          "location": {
            "id": 1,
            "city": "Providence",
            "state": "Rhode Island",
            "country": "United States",
            "online": false
          },
          "name": "Brown University",
          "level": "Postsecondary",
          "degree_type": "Bachelor's Degree",
          "program_one": "Sc.B. in Computer Science",
          "program_two": "A.B. in Engineering",
          "program_three": null,
          "start_date": "2017-09-05",
          "end_date": "2021-12-31",
          "status": "Break"
        },
        "keywords": [],
        "course_code": "CSCI0170",
        "subject": null,
        "name": "Computer Science: An Integrated Introduction",
        "description": "",
        "TA": true,
        "professor_info": null,
        "semester_level": 1
      },
      "name": "Connect4 Implementation",
      "team_size": 1,
      "start_date": "2017-12-01",
      "end_date": "2017-12-01",
      "description": "",
      "project_url": "",
      "source_url": "",
      "extra": null
    },
    {
      "id": 4,
      "keywords": [
        {
          "id": 4,
          "name": "Computer Graphics"
        }
      ],
      "stack": [
        {
          "id": 14,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "C++",
          "proficiency": "intermediate"
        }
      ],
      "location": {
        "city": null,
        "state": null,
        "country": null
      },
      "course": {
        "id": 19,
        "school": {
          "id": 1,
          "location": {
            "id": 1,
            "city": "Providence",
            "state": "Rhode Island",
            "country": "United States",
            "online": false
          },
          "name": "Brown University",
          "level": "Postsecondary",
          "degree_type": "Bachelor's Degree",
          "program_one": "Sc.B. in Computer Science",
          "program_two": "A.B. in Engineering",
          "program_three": null,
          "start_date": "2017-09-05",
          "end_date": "2021-12-31",
          "status": "Break"
        },
        "keywords": [],
        "course_code": "CSCI1230",
        "subject": "Computer Science",
        "name": "Introduction to Computer Graphics",
        "description": "",
        "TA": false,
        "professor_info": null,
        "semester_level": 5
      },
      "name": "3D Billiard Game Simulation",
      "team_size": 3,
      "start_date": "2019-11-01",
      "end_date": "2019-12-01",
      "description": "Developed an interactive billiard game in C++ with OpenGL. Implemented collision detection, shadow mapping, texture mapping, and bump mapping.",
      "project_url": "",
      "source_url": "https://github.com/estherkim99/cs123-final",
      "extra": null
    },
    {
      "id": 2,
      "keywords": [
        {
          "id": 3,
          "name": "Computer Vision"
        },
        {
          "id": 8,
          "name": "Machine Learning"
        }
      ],
      "stack": [
        {
          "id": 32,
          "category": [
            {
              "id": 5,
              "name": "Computer Vision"
            }
          ],
          "name": "TensorFlow",
          "proficiency": null
        },
        {
          "id": 33,
          "category": [
            {
              "id": 5,
              "name": "Computer Vision"
            }
          ],
          "name": "Keras",
          "proficiency": null
        }
      ],
      "location": {
        "city": null,
        "state": null,
        "country": null
      },
      "course": {
        "id": 21,
        "school": {
          "id": 1,
          "location": {
            "id": 1,
            "city": "Providence",
            "state": "Rhode Island",
            "country": "United States",
            "online": false
          },
          "name": "Brown University",
          "level": "Postsecondary",
          "degree_type": "Bachelor's Degree",
          "program_one": "Sc.B. in Computer Science",
          "program_two": "A.B. in Engineering",
          "program_three": null,
          "start_date": "2017-09-05",
          "end_date": "2021-12-31",
          "status": "Break"
        },
        "keywords": [],
        "course_code": "CSCI1430",
        "subject": "Computer Science",
        "name": "Computer Vision",
        "description": "",
        "TA": false,
        "professor_info": null,
        "semester_level": 6
      },
      "name": "Text to Image DCGAN Generator using ImageNet Dog Dataset",
      "team_size": 3,
      "start_date": "2020-04-01",
      "end_date": "2020-05-01",
      "description": "Trained a Deep Convolutional GAN on ImageNet dog dataset using Tensorflow to design a network that generates dog images given a dog breed.",
      "project_url": "",
      "source_url": "https://github.com/agoodcupofjoe/CSCI1430_Final_Project",
      "extra": null
    },
    {
      "id": 3,
      "keywords": [
        {
          "id": 9,
          "name": "Computer Systems"
        }
      ],
      "stack": [
        {
          "id": 13,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "C",
          "proficiency": "advanced"
        },
        {
          "id": 21,
          "category": [
            {
              "id": 3,
              "name": "DevOps Tools"
            }
          ],
          "name": "Vagrant",
          "proficiency": null
        }
      ],
      "location": {
        "city": null,
        "state": null,
        "country": null
      },
      "course": {
        "id": 23,
        "school": {
          "id": 1,
          "location": {
            "id": 1,
            "city": "Providence",
            "state": "Rhode Island",
            "country": "United States",
            "online": false
          },
          "name": "Brown University",
          "level": "Postsecondary",
          "degree_type": "Bachelor's Degree",
          "program_one": "Sc.B. in Computer Science",
          "program_two": "A.B. in Engineering",
          "program_three": null,
          "start_date": "2017-09-05",
          "end_date": "2021-12-31",
          "status": "Break"
        },
        "keywords": [],
        "course_code": "CSCI1690",
        "subject": "Computer Science",
        "name": "Operating Systems Laboratory",
        "description": "",
        "TA": false,
        "professor_info": null,
        "semester_level": 6
      },
      "name": "Weenix",
      "team_size": 1,
      "start_date": "2020-02-01",
      "end_date": "2020-05-01",
      "description": "Built a Unix-like operating system kernel in C, implementing process management, virtual memory, and file system interfaces.",
      "project_url": "",
      "source_url": "https://github.com/brown-cs1690/weenix-2020-estherkim99",
      "extra": null
    }
  ],
  "personal": [
    {
      "id": 5,
      "keywords": [
        {
          "id": 2,
          "name": "Web Development"
        }
      ],
      "stack": [
        {
          "id": 7,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "HTML",
          "proficiency": "advanced"
        },
        {
          "id": 8,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "CSS",
          "proficiency": "intermediate"
        },
        {
          "id": 9,
          "category": [
            {
              "id": 1,
              "name": "Web Development"
            }
          ],
          "name": "Bootstrap",
          "proficiency": "basic"
        },
        {
          "id": 10,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "JavaScript",
          "proficiency": "advanced"
        },
        {
          "id": 11,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "PHP",
          "proficiency": "basic"
        }
      ],
      "location": {
        "city": null,
        "state": null,
        "country": null
      },
      "name": "Techno I&P Corporation",
      "team_size": 1,
      "start_date": "2019-07-01",
      "end_date": "2019-08-01",
      "description": "Website for Techno I&P Corporation (테크노아이앤피), an industrial goods supplier firm based in South Korea.",
      "project_url": "https://www.techno-inp.com",
      "source_url": "",
      "extra": null
    },
    {
      "id": 1,
      "keywords": [],
      "stack": [
        {
          "id": 5,
          "category": [
            {
              "id": 1,
              "name": "Web Development"
            }
          ],
          "name": "Next.js",
          "proficiency": "intermediate"
        },
        {
          "id": 25,
          "category": [
            {
              "id": 3,
              "name": "DevOps Tools"
            }
          ],
          "name": "Heroku",
          "proficiency": null
        },
        {
          "id": 26,
          "category": [
            {
              "id": 3,
              "name": "DevOps Tools"
            },
            {
              "id": 4,
              "name": "Databases"
            }
          ],
          "name": "Firebase",
          "proficiency": null
        }
      ],
      "location": {
        "city": null,
        "state": null,
        "country": null
      },
      "name": "Pandam Magazine v1",
      "team_size": 1,
      "start_date": "2020-05-15",
      "end_date": "2020-06-15",
      "description": "Designed and developed Next.js web application to view and edit articles for Amsterdam based magazine Pandam.\r\nHosted on Heroku and developed using Google Firebase for user authentication and content database.",
      "project_url": "http://pandam-magazine.com",
      "source_url": "",
      "extra": null
    },
    {
      "id": 2,
      "keywords": [
        {
          "id": 2,
          "name": "Web Development"
        }
      ],
      "stack": [
        {
          "id": 4,
          "category": [
            {
              "id": 1,
              "name": "Web Development"
            }
          ],
          "name": "Hugo",
          "proficiency": null
        },
        {
          "id": 7,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "HTML",
          "proficiency": "advanced"
        },
        {
          "id": 8,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "CSS",
          "proficiency": "intermediate"
        },
        {
          "id": 28,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "Markdown",
          "proficiency": null
        }
      ],
      "location": {
        "city": null,
        "state": null,
        "country": null
      },
      "name": "Pandam Magazine v0",
      "team_size": 1,
      "start_date": "2020-02-01",
      "end_date": "2020-02-15",
      "description": "Designed and developed a static website for Amsterdam based magazine Pandam using Hugo to view articles formatted in Markdown.\r\nHosted through Github Pages.",
      "project_url": "",
      "source_url": "https://github.com/estherkim99/pandam-web-v0",
      "extra": null
    },
    {
      "id": 6,
      "keywords": [
        {
          "id": 2,
          "name": "Web Development"
        }
      ],
      "stack": [
        {
          "id": 1,
          "category": [
            {
              "id": 1,
              "name": "Web Development"
            }
          ],
          "name": "React.js",
          "proficiency": "intermediate"
        },
        {
          "id": 7,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "HTML",
          "proficiency": "advanced"
        },
        {
          "id": 8,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "CSS",
          "proficiency": "intermediate"
        },
        {
          "id": 10,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "JavaScript",
          "proficiency": "advanced"
        }
      ],
      "location": {
        "city": null,
        "state": null,
        "country": null
      },
      "name": "thisbook Reading Preference Test",
      "team_size": 1,
      "start_date": "2020-09-10",
      "end_date": null,
      "description": "React application that provides reading style preference test for users of <a href='https://www.thisbookmoim.com'>이책 (thisbook)</a>, a platform for forming book discussion clubs online.",
      "project_url": "https://estherkim99.github.io/reading-preference-test/",
      "source_url": "https://github.com/estherkim99/reading-preference-test",
      "extra": null
    },
    {
      "id": 4,
      "keywords": [
        {
          "id": 2,
          "name": "Web Development"
        }
      ],
      "stack": [
        {
          "id": 2,
          "category": [
            {
              "id": 1,
              "name": "Web Development"
            }
          ],
          "name": "Django",
          "proficiency": "intermediate"
        },
        {
          "id": 1,
          "category": [
            {
              "id": 1,
              "name": "Web Development"
            }
          ],
          "name": "React.js",
          "proficiency": "intermediate"
        },
        {
          "id": 7,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "HTML",
          "proficiency": "advanced"
        },
        {
          "id": 8,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "CSS",
          "proficiency": "intermediate"
        },
        {
          "id": 10,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "JavaScript",
          "proficiency": "advanced"
        },
        {
          "id": 25,
          "category": [
            {
              "id": 3,
              "name": "DevOps Tools"
            }
          ],
          "name": "Heroku",
          "proficiency": null
        },
        {
          "id": 36,
          "category": [
            {
              "id": 4,
              "name": "Databases"
            }
          ],
          "name": "PostgreSQL",
          "proficiency": null
        }
      ],
      "location": {
        "city": null,
        "state": null,
        "country": null
      },
      "name": "Portfolio Website",
      "team_size": 1,
      "start_date": "2020-09-25",
      "end_date": null,
      "description": "Developed this portfolio website using Django Rest Framework for building API for content delivery and React.js for front-end. The API and is hosted on Heroku along with the PostgreSQL content database.",
      // "project_url": "https://estherkim99.github.io",
      "source_url": "https://github.com/estherkim99/portfolio-website",
      "video_url": "https://youtu.be/PptIs-tXn6w",
      "extra": null
    },
    {
      "id": 3,
      "keywords": [
        {
          "id": 2,
          "name": "Web Development"
        }
      ],
      "stack": [
        {
          "id": 1,
          "category": [
            {
              "id": 1,
              "name": "Web Development"
            }
          ],
          "name": "React.js",
          "proficiency": "intermediate"
        },
        {
          "id": 10,
          "category": [
            {
              "id": 2,
              "name": "Programming Languages"
            }
          ],
          "name": "JavaScript",
          "proficiency": "advanced"
        },
        {
          "id": 26,
          "category": [
            {
              "id": 3,
              "name": "DevOps Tools"
            },
            {
              "id": 4,
              "name": "Databases"
            }
          ],
          "name": "Firebase",
          "proficiency": null
        }
      ],
      "location": {
        "city": null,
        "state": null,
        "country": null
      },
      "name": "VERA",
      "team_size": 3,
      "start_date": "2020-01-25",
      "end_date": "2020-01-26",
      "description": "Built a React-based web application that verifies the authenticity of news articles based on a crowdsourced voting system.\r\nIntegrated Google Firebase for hosting and managing the user-submitted articles on a real-time database. \r\nSubmission for Hack at Brown 2020",
      "project_url": "",
      "source_url": "https://github.com/estherkim99/hackatbrown2020",
      "extra": null
    },
    {
      "name": "Course Website for CSCI167/9 @ Brown University",
      "start_date": "2021-01-15",
      "end_date": "2021-01-20",
      "project_url": "https://brown-cs1690.github.io/brown-cs167-s21/",
      "video_url": "https://youtu.be/8t9tXPTHt8g",
      "stack": [
        {name: "Vue.js"}
      ],
      "keywords": [],
      "description": "A course website for CSCI167/9 Operating Systems course at Brown University for Spring 2021 semester. While working as a teaching assistant for the course, I developed this website using Vue.js and hosted it using Github Pages."
    },
    {
      "name": "Fud",
      "start_date": "2021-01-23",
      "end_date": "2021-01-24",
      "video_url": "https://youtu.be/ffxqeVHtBeU",
      "project_url": "https://fud-u-design.firebaseapp.com/",
      "source_url": "https://github.com/estherkim99/fud",
      "stack": [
        {name: "Firebase"},
        {name: "React.js"}
      ],
      "keywords": [],
      "description": "A course website for CSCI167/9 Operating Systems course at Brown University for Spring 2021 semester. While working as a teaching assistant for the course, I developed this website using Vue.js and hosted it using Github Pages."
    }
  ]
}

export { apiInfo, socialMediaLinks, homeTexts, projectTexts, cvTexts, cvData, projectData };
